document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('[data-guide-tab]');
  const panels = document.querySelectorAll('[data-guide-panel]');

  if (!tabs.length || !panels.length) {
    return;
  }

  function activateGuide(target) {
    tabs.forEach(function (tab) {
      const isActive = tab.dataset.guideTab === target;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      const isActive = panel.dataset.guidePanel === target;
      panel.classList.toggle('is-active', isActive);
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function (event) {
      const target = tab.dataset.guideTab;

      if (!target) {
        return;
      }

      event.preventDefault();
      activateGuide(target);
    });
  });

  const firstActiveTab = document.querySelector('[data-guide-tab].is-active');
  const firstTarget = firstActiveTab ? firstActiveTab.dataset.guideTab : tabs[0].dataset.guideTab;

  if (firstTarget) {
    activateGuide(firstTarget);
  }
});